import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { cta, price, productName } from '../data/content';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const offerSection = document.getElementById('oferta');
      if (!offerSection) {
        setVisible(false);
        return;
      }
      setVisible(offerSection.getBoundingClientRect().bottom <= window.innerHeight);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-179" data-mp="c5xs177ts1ma">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-ink-line bg-ink/95 px-4 py-3 backdrop-blur" data-id="element-180" data-mp="c55wtxi545wj">
          <div className="mx-auto flex max-w-content items-center justify-between gap-4" data-id="element-181" data-mp="gw79a1ex2uyl">
            <div className="hidden sm:block" data-id="element-182" data-mp="c58lkgrlmulb">
              <p className="font-sans text-sm font-semibold text-ivory" data-id="element-183" data-mp="c3e4jdjg7mmi">
                {productName} · 6 tomos + 5 bonos prácticos
              </p>
              <p className="font-sans text-xs text-ivory/65" data-id="element-184" data-mp="lv1wrgntx7p1">
                <span className="font-semibold text-mustard" data-id="element-185" data-mp="lwuwsd3xsto2">{price}</span> · Pago único · Garantía de 7 días
              </p>
            </div>
            <CtaButton className="sm:w-auto sm:px-8" data-id="element-186" data-mp="uuyk9eyhg0ii">{cta.primary}</CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}